'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Accordion = function () {
  function Accordion(node) {
    (0, _classCallCheck3.default)(this, Accordion);

    this.blocks = node;
  }

  (0, _createClass3.default)(Accordion, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.blocks.forEach(function (el) {
        el.addEventListener('click', _this.toggle.bind(_this));
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(_ref) {
      var target = _ref.target;

      if (target.dataset.accordionBtn === '') {
        if (target.classList.toggle('open')) {
          this.open(target);
        } else {
          this.close(target);
        }
      }
    }
  }, {
    key: 'open',
    value: function open(el) {
      var content = el.nextElementSibling;
      var height = this.getHeight(content);
      this.setHeight(height, content);
    }
  }, {
    key: 'close',
    value: function close(el) {
      var content = el.nextElementSibling;
      this.setHeight(0, content);
    }
  }, {
    key: 'getHeight',
    value: function getHeight(node) {
      return [].concat((0, _toConsumableArray3.default)(node.children)).reduce(function (acc, el) {
        return acc + el.offsetHeight + parseInt(window.getComputedStyle(el).marginBottom, 10);
      }, 0);
    }
  }, {
    key: 'setHeight',
    value: function setHeight(height, el) {
      Object.assign(el.style, { height: height + 'px' });
    }
  }]);
  return Accordion;
}();

var accordionBlocks = document.querySelectorAll('[data-accordion]');
var blocks = new Accordion(accordionBlocks);
blocks.init();